"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuperadminGuard = SuperadminGuard;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var routes_1 = require("../../constants/routes");
var hooks_1 = require("../../store/hooks");
var roles_1 = require("../../utils/roles");
function SuperadminGuard() {
    var user = (0, hooks_1.useAppSelector)(function (state) { return state.user.user; });
    if (!(0, roles_1.isSystemAdministratorRole)(user)) {
        return (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: routes_1.ROUTES.TASKS_DASHBOARD, replace: true });
    }
    return (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {});
}
